import React from 'react'
import PropTypes from 'prop-types'
import { CircularProgress } from '@material-ui/core'
import { Page, Header } from 'components'
import { Form } from './Form'
import { useReconhecimentoCadaver } from './hooks/useReconhecimentoCadaver'
import useStyles from './ReconhecimentoCadaver.styles'

export const ReconhecimentoCadaver = (props) => {
  const { route } = props
  const classes = useStyles()
  
  const {
    cadaver,
    processando,
  } = useReconhecimentoCadaver(props)

  return (
    <Page className={classes.root} title={`${route.titulo} - SIGEP`}>
      <Header titulo={route.titulo} overline={route.secao} />
      
      <div className={classes.formContainer}>
        {processando && !cadaver.id ? (
          <div className={classes.carregando}>
            <CircularProgress disableShrink />
          </div>
        ) : (
          /* Renderização direta do Formulário sem Card wrapper (Layout Flattening 🛸🚀) */
          <Form className={classes.form} cadaver={cadaver} />
        )}
      </div>
    </Page>
  )
}

ReconhecimentoCadaver.propTypes = {
  route: PropTypes.object.isRequired,
}
